import { WSService } from "../../../utils/WSService";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/onboarding/acknowledgements");

// Still on v1: v3 acceptAcknowledgement cannot record a `NotGiven` status —
// see useMutationUpdateAcknowledgement. Reads live on v3
// (queriesAcknowledgements.getAcknowledgement).
export const updateAcknowledgement = async (
  acknowledgementName: onboardingApiSpec.AcknowledgementName,
  requestBody: onboardingApiSpec.operations["updateAcknowledgement"]["requestBody"]["content"]["application/json"]
): Promise<
  onboardingApiSpec.operations["updateAcknowledgement"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("/" + acknowledgementName, requestBody);
  return data;
};
